import React from "react";
import TableView from "../../tables/TableView";
import AddNewButton from "../../buttons/AddNewButton";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Nazov", "caption": "Názov"},
    {"label": "Odhad_Vratenia_Dni", "caption": "Odhad Vrátenia - Dni", 'filter': 'string'}
]


function LoanTypes(props) {
    const baseUrl = '/loan/loans_types'
    const baseUrlFrontend = '/loan_types/loan_type'
    const initialFilters = []
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Nazov': `${baseUrlFrontend}/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={baseUrlFrontend}
            // filters={filters}
            // filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Typy Zápožičky"}
        />
        // <div>
        //     <TableView links={links} headers={headers} data={data} delete_single={delete_single} label="Typy servisných prípadov"/>
        //     <AddNewButton link={`${baseUrlFrontend}/new`}/>
        // </div>
    )
}

export default LoanTypes
